























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import draggable from "vuedraggable";
import axios, { axiosM, resHandle } from "../../../../plugins/axios";
import { GetDictionary } from "@/request/moban";
import CustomTransferCmp from "./customMobans/customTransferCmp.vue";
import mobanData from "./customMobanData";
@Component({
  components: {
    draggable,
    CustomTransferCmp,
  },
})
export default class ProjectCreateThirdCustomCmp extends Vue {
  @Prop()
  private groupId: any;
  @Prop()
  private groupName: any;
  @Prop()
  private cFangshi: any;
  @Prop()
  private cTemplate: any;
  @Prop()
  private isHideTop: any;
  private mobanData = mobanData;
  private optionsOpen: any = { 患者人口学信息: true };
  private cOptionName: any = "人口学信息";
  private cOption: any = {};
  private cSubOptionName: any = "";
  private ziduans: any = {};
  private resultList: any[] = [];
  // 修改名称弹窗
  private ifShowMobanNameDialog: boolean = false;
  private mobanName: any = "";
  /**
   * @description 返回分组页
   */
  private backToSecond() {
    this.$router.push(
      "/main/project/project-create-second/" + this.cFangshi.project_id
    );
  }
  /**
   * @description 返回模板列表页
   */
  private backToList() {
    this.$emit("cStateChange", "list");
  }
  /**
   * @description 切换自定义字段
   */
  private goToControl() {
    this.$emit("cStateChange", "control");
  }
  /**
   * @description 切换系统模板
   */
  private goToSystemMoban() {
    this.$emit("cStateChange", "system");
  }
  /**
   * @description 开关左侧列表
   */
  private triggerOptionsOpen(name) {
    const bool = this.optionsOpen[name];
    this.optionsOpen = {};
    this.optionsOpen[name] = !bool;
    // this.optionsOpen[name] = !this.optionsOpen[name];
    this.$forceUpdate();
  }
  /**
   * @description 获取后端保存的所有模板字段
   */
  private fetchZiduans() {
    const loading = this.$loading({
      text: "加载中...",
    });
    GetDictionary(this, "custom")
      .then((data: any) => {
        this.ziduans = data;
        this.showSubOptions("人口学信息");
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 切换第二列字段显示
   */
  private showSubOptions(name) {
    this.cOptionName = name;
    this.cOption = this.ziduans[name];
  }
  /**
   * @description 将字段添加到右边
   */
  private addZiduan(ziduan) {
    if (ziduan["type"] === "单个时间") {
      ziduan["format"] = "date";
    }
    this.resultList.push(ziduan);
    this.resultList = _.uniqBy(this.resultList, "id");
  }
  /**
   * @description 删除某个自定义字段
   */
  private deleteOneZiduan(index) {
    this.resultList.splice(index, 1);
  }
  /**
   * @description 打开添加量表名称弹窗
   */
  private openInputNameDialog() {
    this.ifShowMobanNameDialog = true;
  }
  /**
   * @description 保存模板
   */
  private save() {
    if (!this.mobanName) {
      return;
    }
    const params: any = {
      project_id: this.cFangshi.project_id,
      group_id: this.cFangshi.group_id,
      interview_id: this.cFangshi.interview_id,
      名称: this.mobanName,
      模板: this.resultList,
      类别: "自定义模板",
    };
    if (this.cTemplate.template_id) {
      params.template_id = this.cTemplate.template_id;
    }
    axios.post("api/project/template", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("保存成功");
        if (this.isHideTop) {
          this.$router.push({
            path: "/main/project/crf-list",
          });
        } else {
          this.$emit("cStateChange", "list");
        }
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    console.log("模板");
    console.log(this.cTemplate);
    this.cOption = {};
    this.fetchZiduans();
    if (this.cTemplate.template_id) {
      this.resultList = this.cTemplate["模板"];
      this.mobanName = this.cTemplate.name;
    }
  }
  private test() {
    console.log(this.resultList);
  }
}
